/**
 * 【KYMW1400】ページIDVO
 *
 * @export PageIDModel
 * @class PageIDModel
 */
export class PageIDModel {
  /**
   *  ページID
   */
  public pageID = Number(0);

  /**
   *  媒体区分
   */
  public mediumType = String('');
}
